if(typeof open-ask-ai === 'undefined') { var e = new Error("Cannot find module 'open-ask-ai'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = open-ask-ai;